import { SectorPage } from "../../pages/btwtoolpages/SectorPage";
import { ActivityTypePage } from "../../pages/btwtoolpages/ActivityTypePage";
import { NonExemptTurnOverPage } from "../../pages/btwtoolpages/NonExemptTurnOverPage";
import { TurnOverPage } from "../../pages/btwtoolpages/TurnOverPage";
import { Sector, ActivityType, NonExemptTurnOver, TurnOver } from "./btwtoolenums";
import { ValueAndPage } from "../statemachine/valueandpage";

export class BTWToolState {
    sector: ValueAndPage<Sector>
    activityType: ValueAndPage<ActivityType>
    nonExemptTurnOver: ValueAndPage<NonExemptTurnOver>
    turnOver: ValueAndPage<TurnOver>

    constructor({ sector,
        activityType,
        nonExemptTurnOver,
        turnOver }
        : {
            sector?: Sector,
            activityType?: ActivityType,
            nonExemptTurnOver?: NonExemptTurnOver,
            turnOver?: TurnOver
        } = {}) {
        this.sector = new ValueAndPage<Sector>(SectorPage, sector)
        this.activityType = new ValueAndPage<ActivityType>(ActivityTypePage, activityType)
        this.nonExemptTurnOver = new ValueAndPage<NonExemptTurnOver>(NonExemptTurnOverPage, nonExemptTurnOver)
        this.turnOver = new ValueAndPage<TurnOver>(TurnOverPage, turnOver)
    }
}